import { type Locale, queryClient, useLocale } from '@capsicum/common';
import { useCallback } from 'react';

import { useUpdateUserDetails } from '../data-access';

export const useChangeLanguage = () => {
	const { setLocale } = useLocale();
	const { isLoading: isUpdateUserDetailsLoading, mutateAsync: updateUserDetails } = useUpdateUserDetails();

	// TODO: add insert coins feature
	const onChangeLanguage = useCallback(
		async (locale: Locale) => {
			setLocale(locale);
			await updateUserDetails({ locale });
			queryClient.invalidateQueries();
		},
		[setLocale, updateUserDetails]
	);

	return {
		isLoading: isUpdateUserDetailsLoading,
		onChangeLanguage
	};
};
